import { render, staticRenderFns } from "./ModulesAccordion.vue?vue&type=template&id=7bf932b9"
import script from "./ModulesAccordion.vue?vue&type=script&lang=js"
export * from "./ModulesAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SnippetAccordion: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetAccordion.vue').default})
